export default function Avatar({ name, src, size = 32, className = "" }) {
  const ini = (name || "?").split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase();
  const palettes = ["gradient-primary", "gradient-success", "gradient-warning", "gradient-cyan"];
  const idx = (name || "").charCodeAt(0) % 4;

  if (src) {
    return (
      <img
        src={src}
        alt={name || "Avatar"}
        className={`flex-shrink-0 rounded-full object-cover border border-slate-200 dark:border-slate-700 ${className}`}
        style={{ width: size, height: size }}
        onError={(e) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    );
  }

  return (
    <div className={`flex-shrink-0 flex items-center justify-center rounded-full text-white font-bold ${palettes[idx]} ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.35 }}>{ini}</div>
  );
}
